import React, { FC } from 'react'
import { motion } from 'framer-motion'
import Heading from '../../atoms/Heading/Heading'
import { getImage } from '../../../app/utlis/imageConstants'
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg'
interface ReliabilityAndroidStepsProps {
    androidData: any
}

const ReliabilityAndroidSteps: FC<ReliabilityAndroidStepsProps> = ({ androidData }) => {
    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3
            }
        }
    }

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    }

    return (
        <motion.div 
            className='p-4 sm:p-6 md:p-8 pt-8 md:pt-12'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
        >
            <Heading subTitle='Reliability in every step' />
            <motion.div 
                className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 lg:gap-8 lg:gap-12 p-0 md:p-12 lg:p-20 pt-8 lg:pt-16  md:px-0  xl:px-36'
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {androidData.ReliabilityAndroidData.map((reliable: any, index: number) => {
                     let img = getImage(reliable.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            className="relative p-[2px] rounded-3xl bg-transparent" 
                            variants={itemVariants}
                            initial={{
                                backgroundImage: 'none'
                            }}
                            whileHover={{
                                backgroundImage: `linear-gradient(156deg, ${reliable.bgColor} -38.83%, ${reliable.bgColor}00 100.93%)`,
                                scale: 1.05,
                                transition: { duration: 0.3 }
                            }}
                        >
                            <div className='flex flex-col items-center justify-start rounded-3xl p-4 md:px-3 md:py-4 lg:p-8 bg-blackDark h-full' >
                                <motion.div 
                                    className={`w-[50px] h-[50px] md:w-[60px] md:h-[60px] p-3 md:p-4 bg-${reliable.color} rounded-full flex items-center justify-center mb-3 md:mb-4`}
                                    initial={{ scale: 0 }}
                                    animate={{ scale: 1 }}
                                    transition={{ 
                                        delay: 0.2 + (index * 0.1),
                                        duration: 0.6,
                                        type: "spring",
                                        stiffness: 200
                                    }}
                                >
                                     <DynamicSVG color='#fff' size='w-full'>{img}</DynamicSVG>
                                </motion.div>
                                <motion.div 
                                    className={`text-base sm:text-lg md:text-xl text-center font-semibold text-${reliable.color}`}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.4 + (index * 0.1), duration: 0.5 }}
                                >
                                    {reliable.title}
                                </motion.div>
                                <motion.div 
                                    className='text-white text-center text-sm md:text-base lg:text-lg px-2 sm:px-3 md:px-4'
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.5 + (index * 0.1), duration: 0.5 }}
                                >
                                    {reliable.subtitle}
                                </motion.div>
                            </div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </motion.div>
    )
}

export default ReliabilityAndroidSteps
